/**
 * Still / poster / hed URLs to warm before a chapter wipe. Videos stay out —
 * posters cover the first paint; loops buffer once the chapter is on stage.
 */

import { arizonaSlideMedia } from "@story/data-centers-hub/config/arizonaAssets";
import { ballastSlideSrc } from "@story/data-centers-hub/config/ballastAssets";
import { loudounSlideMedia } from "@story/data-centers-hub/config/loudounAssets";
import type { DeckSlideId } from "@story/data-centers-hub/config/slides";
import {
  titleSlideMedia,
  type TitleMedia,
} from "@story/data-centers-hub/config/titleAssets";
import { utahSlideMedia } from "@story/data-centers-hub/config/utahAssets";

function ballastUrl(id: DeckSlideId): string[] {
  const src = ballastSlideSrc[id];
  return src ? [src] : [];
}

function stillUrls(media: TitleMedia): string[] {
  if (media.kind === "image") {
    return [media.src];
  }
  return media.posterMobile
    ? [media.poster, media.posterMobile]
    : [media.poster];
}

export function chapterWarmUrls(id: DeckSlideId): readonly string[] {
  switch (id) {
    case "title":
      return [
        ...stillUrls(titleSlideMedia.tlTop),
        ...stillUrls(titleSlideMedia.tlBottom),
        ...stillUrls(titleSlideMedia.tm),
        ...stillUrls(titleSlideMedia.tr),
        ...stillUrls(titleSlideMedia.blMerged),
        ...stillUrls(titleSlideMedia.brTop),
        ...stillUrls(titleSlideMedia.brBottom),
        titleSlideMedia.hed,
        titleSlideMedia.hedMobile,
        ...ballastUrl("title"),
      ];
    case "virginia":
      return [
        ...stillUrls(loudounSlideMedia.video),
        ...stillUrls(loudounSlideMedia.left),
        ...stillUrls(loudounSlideMedia.br),
        loudounSlideMedia.hed,
        loudounSlideMedia.hedMobile,
        ...ballastUrl("virginia"),
      ];
    case "utah":
      return [
        ...stillUrls(utahSlideMedia.stratos),
        ...stillUrls(utahSlideMedia.getty),
        ...stillUrls(utahSlideMedia.people),
        ...stillUrls(utahSlideMedia.site),
        utahSlideMedia.hedPeople,
        utahSlideMedia.hedOleary,
        ...ballastUrl("utah"),
      ];
    case "arizona":
      return [
        ...stillUrls(arizonaSlideMedia.main),
        ...stillUrls(arizonaSlideMedia.irrigation),
        ...stillUrls(arizonaSlideMedia.tl),
        ...stillUrls(arizonaSlideMedia.bl),
        arizonaSlideMedia.hed,
        arizonaSlideMedia.hedMobile,
        ...ballastUrl("arizona"),
      ];
    case "note":
    case "credits":
      return [];
    default: {
      const _exhaustive: never = id;
      return _exhaustive;
    }
  }
}
